<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getRepaymentDetailHistoryHeaders()"
    :items="getItems ()"
    :loading="historyLoading"
    :items-per-page="rowsPerPage"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template
      slot="headerCell"
      slot-scope="{ header }">
      <span
        class="subheading font-weight-light krita-dark text--darken-3"
        v-text="header.text" />
    </template>
    <template v-slot:no-data>
      <v-layout
        v-if="historyLoading"
        align-center
        justify-center
        row
        fill-height>

        <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="primary"
        />
      </v-layout>
      <v-layout
        v-if="!historyLoading"
        align-center
        justify-center
        row
        fill-height>
        <span>{{ 'krita.datagrid.nodata' | translate }}</span>
      </v-layout>
    </template>
    <template v-slot:items="props">
      <td>{{ props.item.Status }}</td>
      <td>{{ props.item.DebtorName }} ehf (kt. {{ props.item.DebtorRegistryId | kennitala }})</td>
      <td>{{ props.item.ExpirationDate | date }}</td>
      <td>{{ props.item.Capital | amount }}</td>
      <td>{{ props.item.Penalty | amount }}</td>
      <td>{{ props.item.Modified | date }}</td>
      <td>{{ props.item.ModifiedBy }}</td>
      <td>{{ props.item.Action }}</td>
    </template>
  </v-data-table>
</template>

<script>
import EnumIterator from '../helper/EnumIterator';
    export default {
      name: "HistoryDatagrid",
      props: ['history', 'historyLoading','rowsPerPage'],
      methods: {
        getRepaymentDetailHistoryHeaders()
        {
          return [
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.status'), value: 'status'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.debtor'), value: 'debtor'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.expirationdate'), value: 'expirationdate'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.capital'), value: 'capital'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.penaltyamount'), value: 'penaltyamount'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.modified'), value: 'modified'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.modifiedby'), value: 'modifiedby'},
            {sortable: false, text: this.$t('krita.repaymentdetail.history.header.action'), value: 'action'},
          ]
        },
        getItems ()
        {
          let self = this;

          let items = [];

          for (let row of self.history)
          {
            let historyRowClient = {
              Action: self.$t(EnumIterator.processDatabaseAction(row.Action)),
              BankClaimId: row.BankClaimId,
              Capital: row.Capital,
              ClaimantName: row.ClaimantName,
              Created: row.Created,
              CreatedBy: row.CreatedBy,
              DebtorName: row.DebtorName,
              DebtorRegistryId: row.DebtorRegistryId,
              ExpirationDate: row.ExpirationDate,
              Id: row.Id,
              Modified: row.Modified,
              ModifiedBy: row.ModifiedBy,
              Penalty: row.Penalty,
              Processed: row.Processed,
              Status: self.$t(EnumIterator.processRepaymentStatus(row.Status)),
              TransactionId: row.TransactionId,
              Type: self.$t(EnumIterator.processRepaymentType(row.Type)),
            };
            items.push(historyRowClient);
          }
          return items;
        },
      }
    }
</script>

<style scoped>

</style>
